// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-user-send-message-history-tab .history-period .title[data-v-c3773286]{font-weight:700}.other-user-send-message-history-tab .history-period .history-option[data-v-c3773286]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
